import {
  Box,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Switch,
  Typography,
} from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import { TaxTypeModel } from '../../../../config/types/models/TaxTypeModel';

type IProps = {
  isActive: boolean;
  isFeatured: boolean;
  setIsActive: (a: boolean) => void;
  setIsFeatured: (a: boolean) => void;
  taxType: number;
  allTaxTypes: TaxTypeModel[];
  setTaxType: (a: number) => void;
};
function BooleansInfo({
  isActive,
  isFeatured,
  taxType,
  allTaxTypes,
  setIsActive,
  setIsFeatured,
  setTaxType,
}: IProps) {
  const t = useTranslate();

  return (
    <Paper sx={{ padding: 1, marginTop: 1 }}>
      <Typography variant='subtitle1'>{t('Status')}</Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <FormControlLabel
          control={
            <Switch
              defaultChecked
              checked={isActive}
              color='success'
              onChange={() => setIsActive(!isActive)}
            />
          }
          label={t('active')}
        />
        <FormControlLabel
          defaultChecked={false}
          control={
            <Switch
              color='warning'
              checked={isFeatured}
              onChange={() => setIsFeatured(!isFeatured)}
            />
          }
          label={t('feature')}
        />
      </Box>
      <Box>
        <Select
          value={taxType}
          variant='outlined'
          label={t('taxType')}
          sx={{ width: '100%', marginTop: 1 }}
          onChange={(e) => setTaxType(parseInt(e.target.value.toString()))}
        >
          {allTaxTypes?.map((tx) => (
            <MenuItem value={tx.id}>{tx.name}</MenuItem>
          ))}
        </Select>
      </Box>
    </Paper>
  );
}

export default BooleansInfo;
